export const loadingStatuses = {
  PENDING: 'loadingStatuses/pending',
  LOADED: 'loadingStatuses/loaded',
}

export const WIDESCREEN_WIDTH = 1280;
export const DESKTOP_WIDTH = 1000;
export const TABLET_WIDTH = 768;
export const MOBILE_WIDTH = 480;
